import styled from 'styled-components';
import { media } from './styles-helper';

const Container = styled.div`
  width: 500px;
  padding: 0 20px;
  margin: 20px auto 0 auto;
  
  ${media.phone`
    width: 320px;
    padding: 0 10px;
  `}
`;

export {
  Container,
}



// WEBPACK FOOTER //
// ./src/styles.js